import React, { useState } from 'react';
import { ChevronDownIcon } from '../../constants/icons';

/**
 * Accessible FAQ disclosure. The answer text stays in the DOM so it is
 * crawlable and matches the FAQPage JSON-LD.
 */
export default function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="enterprise-card overflow-hidden">
      <button
        type="button"
        className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="text-lg font-semibold text-text-primary">{question}</span>
        <ChevronDownIcon
          className={`h-5 w-5 flex-shrink-0 text-text-secondary transition-transform ${
            open ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div className={`px-6 ${open ? 'pb-5' : 'max-h-0 overflow-hidden'}`}>
        <p className="text-text-secondary leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}
